import {
    DesktopRecruiterBlockerScreen
} from "./components";

const RecruiterBlockerScreen = () => {
    return <DesktopRecruiterBlockerScreen />
}

export default RecruiterBlockerScreen;